<template>
  <div>
  <div class="v-spinner spinner-centrado" v-if="propLoading">
    <div
      class="v-sync v-sync1"
      v-bind:style="[spinnerStyle, spinnerDelay1]"
    ></div>
    <div
      class="v-sync v-sync2"
      v-bind:style="[spinnerStyle, spinnerDelay2]"
    ></div>
    <div
      class="v-sync v-sync3"
      v-bind:style="[spinnerStyle, spinnerDelay3]"
    ></div>
  </div>

  <!-- ============================================================ -->
  <!-- 🛑 ALERTA ANTERIOR (PLATAFORMA DESHABILITADA - COMENTADA)     -->
  <!-- ============================================================ -->

  <v-dialog
    v-model="mostrarModalCentrya"
    max-width="500"
    persistent
    overlay-color="#0a0a1a"
    overlay-opacity="0.88"
  >
    <v-card class="centrya-modal-card" elevation="0">
      <div class="centrya-alert-header">
        <div class="centrya-alert-icon-wrap">
          <v-icon size="40" color="#ffffff">mdi-alert-decagram</v-icon>
        </div>
        <div class="centrya-header-texts">
          <span class="centrya-header-title">Plataforma inhabilitada</span>
          <span class="centrya-header-sub">Aviso importante para asesores {{ nombreEmpresaCentrya }}</span>
        </div>
      </div>
      <v-card-text class="centrya-body">
        <p class="centrya-desc">
          Esta plataforma ha sido <strong>inhabilitada</strong> para la recepción de tickets.
          A partir de ahora, todas las solicitudes deben gestionarse a través de
          <strong>Centrya</strong>, el nuevo Portal Administrativo de {{ nombreEmpresaCentrya }}.
        </p>
        <div class="centrya-info-box">
          <v-icon small color="#c8102e" style="margin-right:6px">mdi-information-outline</v-icon>
          <span>Haz clic en <strong>"Ver guía Centrya"</strong> para ver las instrucciones de uso del nuevo portal.</span>
        </div>
      </v-card-text>
      <v-card-actions class="centrya-actions">
        <v-btn
          depressed
          class="centrya-btn-back"
          @click="regresarAlMenu"
        >
          <v-icon left small>mdi-arrow-left</v-icon>
          Regresar al menú
        </v-btn>
        <v-btn
          depressed
          class="centrya-btn-go"
          @click="abrirPdf"
        >
          <v-icon left small>mdi-file-pdf-box</v-icon>
          Ver guía Centrya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  

  <!-- ============================================================ -->
  <!-- ⚠️ NUEVA ALERTA INFORMATIVA AMARILLA - INHABILITACIÓN 3 NOV -->
  <!--
  <v-dialog
    v-model="mostrarModalInformativo"
    max-width="520"
    persistent
    overlay-color="#0a0a1a"
    overlay-opacity="0.85"
  >
    <v-card class="centrya-warning-card" elevation="0">

      <div class="centrya-warning-header">
        <div class="centrya-warning-icon-wrap">
          <v-icon size="36" color="#ffffff">mdi-alert</v-icon>
        </div>
        <div class="centrya-warning-header-texts">
          <span class="centrya-warning-header-title">Aviso importante</span>
          <span class="centrya-warning-header-sub">Información para asesores {{ nombreEmpresaCentrya }}</span>
        </div>

        <v-btn
          v-if="idEmpresa === 1"
          icon
          dark
          class="centrya-warning-close-btn"
          @click="cerrarAlerta"
          title="Cerrar aviso"
        >
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="centrya-warning-body">
        <p class="centrya-warning-desc">
          Esta plataforma <strong>quedará deshabilitada el próximo 3 de noviembre</strong>.
          A partir de esa fecha, ya no se podrán subir casos por esta plataforma.
        </p>

        <div class="centrya-warning-info-box">
          <v-icon small color="#d97706" style="margin-right:8px; margin-top:2px;">mdi-information-outline</v-icon>
          <span>
            Todas las solicitudes deberán gestionarse a través del portal
            <strong>Centrya</strong>.
          </span>
        </div>
      </v-card-text>

      <v-card-actions class="centrya-warning-actions">
        <v-btn
          depressed
          class="centrya-warning-btn-pdf"
          @click="abrirPdf"
        >
          <v-icon left small>mdi-file-pdf-box</v-icon>
          Ver guía Centrya
        </v-btn>
        <v-btn
          depressed
          class="centrya-warning-btn-portal"
          @click="irACentrya"
        >
          <v-icon left small>mdi-open-in-new</v-icon>
          Ir a Centrya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  -->
  <div id="inspire" class="fuente" v-if="!propLoading">
    <v-toolbar class="nav" dense>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #294697"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn style="background-color: #294697;" dark small depressed @click="logout">NOVA
        <v-icon>mdi-backburger</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm2 md2>
          <v-navigation-drawer
            class="drawer"
            v-model="drawer"
            :temporary="isMobileOrTablet"
            absolute
            :width="280"
            :overlay-opacity="0"
            :hide-overlay="true"
          >
            <div v-if="isMobileOrTablet" class="close-button-container">
              <v-btn
                icon
                @click="drawer = false"
                class="close-btn"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-img :src="require('../../../assets/PANTALLA-03.png')" contain>
              <div style="display: flex; justify-content: center; align-items: center; height: 250px; background-color: #294697;">
                <v-img
                  class="ma-0 pa-0"
                  :src="require('../../../assets/nova/NOMBREBLANCO.png')"
                  max-height="100"
                  contain
                ></v-img>
              </div>
              </v-img>
            <v-list dense>
              <div class="name">{{ nombre }}</div>
              <v-list-item-group color="#294697">
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  :to="item.link"
                  @click="handleNavigation"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content style="width: 144px">
                    <v-menu :nudge-width="30" offset-x @input="handleMenuClose">
                      <template v-slot:activator="{ on }">
                        <v-list-item-title v-on="on"
                          ><v-icon>mdi-alert</v-icon>
                          <span style="margin-left: 12%">TICKETS</span>
                        </v-list-item-title>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-for="(item, i) in subMenu"
                          :key="i"
                          :to="item.link"
                          @click="handleNavigation"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="closeModule">
                  <v-list-item-icon>
                    <v-icon>mdi-power-standby</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title @click="logout"
                      >CERRAR MODULO</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-main>
            <v-container id="myresponsiveCaso">
              <router-view to="children" />
            </v-container>
          </v-main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  </div>
</template>
<script>
import axios from "axios";
import env from "../../env";
export default {
  name: "SyncLoader",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "#294697",
    },
    size: {
      type: String,
      default: "30px",
    },
    margin: {
      type: String,
      default: "2px",
    },
    radius: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      propLoading: this.loading,
      nombre: localStorage.getItem("nombre"),
      id: localStorage.getItem("id"),
      drawer: null,
      // Modal Centrya
      mostrarModalCentrya: true,
      mostrarModalInformativo: true,
      alertaCerrada: false,
      idEmpresa: null,
      urlPdf: '/centrya/guia-centrya-facilisimo.pdf',
      nombreEmpresaCentrya: 'Facilísimo',
      urlCentryaPortal: 'https://portal.apostar.com.co/',
      allItems: [
        /* { text: "INICIO", icon: "mdi-home", link: "/Callcenter/Asesor/Inicio"}, */
        { text: "PANEL BOT NOVA", icon: "mdi-robot", link: "/Callcenter/Asesor/PanelBot", requiresAccess: true},
      ],
      subMenu: [
        {
          text: "NUEVO TICKET",
          icon: "mdi-folder-plus-outline",
          link: "/Callcenter/Asesor/NuevoIncidente",
        },
        {
          text: "CONSULTAR TICKET",
          icon: "mdi-magnify",
          link: "/Callcenter/Asesor/ConsultarIncidente",
        },
      ],
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: "inline-block",
        animationName: "v-syncStretchDelay",
        animationDuration: "0.6s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
        animationFillMode: "both",
      },
      spinnerDelay1: {
        animationDelay: "0.07s",
      },
      spinnerDelay2: {
        animationDelay: "0.14s",
      },
      spinnerDelay3: {
        animationDelay: "0.21s",
      },
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isTablet() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
    },
    isMobileOrTablet() {
      return this.isMobile || this.isTablet;
    },
    // 🔒 Filtrar items del menú según el acceso del usuario
    items() {
      const idUsuario = parseInt(localStorage.getItem('id'), 10);
      const idUsuarioAutorizado = 1;
      
      return this.allItems.filter(item => {
        // Si el item requiere acceso especial, verificar si el usuario está autorizado
        if (item.requiresAccess) {
          const tieneAcceso = idUsuario === idUsuarioAutorizado;
          return tieneAcceso;
        }
        // Si no requiere acceso especial, mostrar siempre
        return true;
      });
    }
  },
  methods: {
    // metodo par cerrar sesión y remover los datos del localStorage
    logout() {
      this.$router.push("/user");
    },
    obtenerUser() {
      axios.get(`${env.endpoint}callcenter/iniciar`).then((res) => {
        // this.nombre = res.data.user.nombre; //Esto nos Arroja error en la promesa de la funcion obtenerUser
        // this.id = res.data.user.id; //Esto nos Arroja error en la promesa de la funcion obtenerUser
      });
    },
    closeModule() {
      window.close();
    },
    handleNavigation() {
      if (this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    handleMenuClose(isOpen) {
      if (!isOpen && this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    // --- Modal Centrya ---
    detectarEmpresa() {
      const idEmpresaRaw = localStorage.getItem('idEmpresa');
      const idEmpresa = idEmpresaRaw !== null && !isNaN(parseInt(idEmpresaRaw, 10))
        ? parseInt(idEmpresaRaw, 10)
        : null;

      this.idEmpresa = idEmpresa;

      console.log('📌 DashBoardAsesor - Centrya Modal - idEmpresa detectado:', idEmpresa, '(raw:', idEmpresaRaw, ')');

      if (idEmpresa === 2) {
        this.nombreEmpresaCentrya = 'Apostar';
        this.urlPdf = '/centrya/guia-centrya-apostar.pdf';
      } else {
        // Facilísimo por defecto o si idEmpresa === 1
        this.nombreEmpresaCentrya = 'Facilísimo';
        this.urlPdf = '/centrya/guia-centrya-facilisimo.pdf';
      }
      if (!this.alertaCerrada) {
        this.mostrarModalInformativo = true;
      }
    },
    cerrarAlerta() {
      if (this.idEmpresa === 1) {
        this.mostrarModalInformativo = false;
        this.alertaCerrada = true;
      }
    },
    irACentrya() {
      window.open(this.urlCentryaPortal, '_blank');
    },
    regresarAlMenu() {
      this.mostrarModalCentrya = false;
      this.mostrarModalInformativo = false;
      this.$router.push('/user');
    },
    abrirPdf() {
      window.open(this.urlPdf, '_blank');
    },
  },
  created() {
    this.detectarEmpresa();
  },
  mounted() {
    this.detectarEmpresa();
    setTimeout(() => {
      this.propLoading = false;
      this.detectarEmpresa();
    }, 1000);
    this.obtenerUser();
  },
};
</script>
<style scoped>

.drawer {
  z-index: 1000 !important;
}
.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}
.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}

@media (max-width: 1000px) {
  #myresponsiveCaso {
    position: fixed;
    top: 45px;
    left: -30px;
    max-width: 550px;
  }
}

@media (min-width: 600px) and (max-width: 1024px) {
  #myresponsiveCaso {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    padding: 16px;
  }
}

@media (min-width: 1025px) {
  #myresponsiveCaso {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
  }
}

/* =============================================
   ESTILOS MODAL CENTRYA
   ============================================= */
.centrya-modal-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff !important;
  border: none;
}

/* Encabezado rojo de alerta */
.centrya-alert-header {
  background: linear-gradient(135deg, #c8102e 0%, #8b0000 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.centrya-alert-icon-wrap {
  background: rgba(255,255,255,0.18);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid rgba(255,255,255,0.35);
}

.centrya-header-texts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.centrya-header-title {
  font-size: 1.2rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.centrya-header-sub {
  font-size: 0.78rem;
  color: rgba(255,255,255,0.75);
  font-weight: 400;
  letter-spacing: 0.2px;
}

.centrya-body {
  padding: 24px 28px 8px !important;
}

.centrya-desc {
  font-size: 0.95rem;
  color: #333;
  line-height: 1.65;
  margin: 0 0 16px 0;
}

.centrya-info-box {
  background: #fff3f3;
  border-left: 3px solid #c8102e;
  border-radius: 6px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  font-size: 0.84rem;
  color: #555;
  line-height: 1.5;
}

.centrya-actions {
  display: flex !important;
  justify-content: space-between !important;
  padding: 12px 28px 24px !important;
  gap: 12px;
}

.centrya-btn-back {
  flex: 1;
  background: #f1f1f1 !important;
  color: #444 !important;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.9rem !important;
  height: 44px !important;
  transition: background 0.2s;
}

.centrya-btn-back:hover {
  background: #e0e0e0 !important;
}

.centrya-btn-go {
  flex: 1;
  background: linear-gradient(135deg, #c8102e 0%, #a00020 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.9rem !important;
  height: 44px !important;
  box-shadow: 0 4px 14px rgba(200, 16, 46, 0.35) !important;
  transition: box-shadow 0.2s, transform 0.15s;
}

.centrya-btn-go:hover {
  box-shadow: 0 6px 20px rgba(200, 16, 46, 0.5) !important;
  transform: translateY(-1px);
}

/* =============================================
   ESTILOS NUEVO MODAL AMARILLO INFORMATIVO CENTRYA
   ============================================= */
.centrya-warning-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff !important;
  border: none;
  position: relative;
}

.centrya-warning-header {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 60%, #b45309 100%);
  padding: 22px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.centrya-warning-icon-wrap {
  background: rgba(255, 255, 255, 0.22);
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.4);
}

.centrya-warning-header-texts {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
  padding-right: 36px;
}

.centrya-warning-header-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.centrya-warning-header-sub {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  letter-spacing: 0.2px;
}

.centrya-warning-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50%;
  transition: background 0.2s, transform 0.15s;
}

.centrya-warning-close-btn:hover {
  background: rgba(255, 255, 255, 0.38) !important;
  transform: scale(1.08);
}

.centrya-warning-body {
  padding: 24px 28px 12px !important;
}

.centrya-warning-desc {
  font-size: 0.98rem;
  color: #2d3748;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.centrya-warning-info-box {
  background: #fffbeb;
  border-left: 4px solid #d97706;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  font-size: 0.88rem;
  color: #78350f;
  line-height: 1.5;
}

.centrya-warning-actions {
  display: flex !important;
  justify-content: space-between !important;
  padding: 14px 28px 24px !important;
  gap: 14px;
}

.centrya-warning-btn-pdf {
  flex: 1;
  background: #f8fafc !important;
  color: #334155 !important;
  border: 1.5px solid #cbd5e1 !important;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.92rem !important;
  height: 44px !important;
  transition: all 0.2s;
}

.centrya-warning-btn-pdf:hover {
  background: #f1f5f9 !important;
  border-color: #94a3b8 !important;
  color: #0f172a !important;
}

.centrya-warning-btn-portal {
  flex: 1;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 60%, #b45309 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.92rem !important;
  height: 44px !important;
  box-shadow: 0 4px 14px rgba(217, 119, 6, 0.35) !important;
  transition: box-shadow 0.2s, transform 0.15s;
}

.centrya-warning-btn-portal:hover {
  box-shadow: 0 6px 20px rgba(217, 119, 6, 0.5) !important;
  transform: translateY(-1px);
}
</style>
